export function ImgArr() {
    //游戏图标
    this["ico_BS"] = require("../img/skin/ico_BS.png");
    this["ico_CD"] = require("../img/skin/ico_CD.png");
    this["ico_CC"] = require("../img/skin/ico_CC.png");
    this["ico_FF"] = require("../img/skin/ico_FF.png");
    this["ico_LM"] = require("../img/skin/ico_LM.png");
    this["ico_LOL"] = require("../img/skin/ico_LL.png");
    this["ico_ML"] = require("../img/skin/ico_ML.png");
    this["ico_PM"] = require("../img/skin/ico_PB.png");
    this["ico_RB"] = require("../img/skin/ico_RB.png");

    //大货币图标
    this["big_BS"] = require("../img/skin/img_BS.png");
    this["big_CD"] = require("../img/skin/img_CD.png");
    this["big_CC"] = require("../img/skin/img_CC.png");
    this["big_FF"] = require("../img/skin/img_FF.png");
    this["big_LM"] = require("../img/skin/img_LM.png");
    this["big_LOL"] = require("../img/skin/img_LL.png");
    this["big_ML"] = require("../img/skin/img_ML.png");
    this["big_PM"] = require("../img/skin/img_PB.png");
    this["big_RB"] = require("../img/skin/img_RB.png");

    //小货币图标
    this["coin_BS"] = require("../img/skin/coin_BS.png");
    this["coin_CD"] = require("../img/skin/coin_CD.png");
    this["coin_CC"] = require("../img/skin/coin_CC.png");
    this["coin_FF"] = require("../img/skin/coin_FF.png");
    this["coin_LM"] = require("../img/skin/coin_LM.png");
    this["coin_LOL"] = require("../img/skin/coin_LL.png");
    this["coin_ML"] = require("../img/skin/coin_ML.png");
    this["coin_PM"] = require("../img/skin/coin_PB.png");
    this["coin_RB"] = require("../img/skin/coin_RB.png");


}
